import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';
import { get_acumulo_inadimplencia_por_mes } from './get_acumulo_inadimplencia_por_mes';

type QueryFnType = typeof get_acumulo_inadimplencia_por_mes;

function useAcumuloInadimplenciaMes(param) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['get_acumulo_inadimplencia_por_mes', param.year],
    queryFn: () => get_acumulo_inadimplencia_por_mes(param),
  });
}

export { useAcumuloInadimplenciaMes };
